import {
    formatNumberForDimensions,
    getDimensionUnit,
    ThicknessType,
    Tolerance,
    TranslateFunc,
} from '@steelbuy/ts-shared';

export const shouldShowVat = (taxPercent?: number): boolean => (taxPercent ?? 0) > 0;

export const shouldShowTolerance = (tolerance?: Tolerance): boolean =>
    tolerance !== undefined && tolerance !== Tolerance.NA;

export const getThicknessTypes = () => [ThicknessType.MIN, ThicknessType.NOM];

export const getThicknessText = (
    thickness: number | string,
    thicknessType: ThicknessType | undefined,
    t: TranslateFunc,
    doFormatting?: boolean
): string => {
    const thicknessWithDimension = t(`domainModel:material.dimensions.units.${getDimensionUnit()}.labelWithValue`, {
        value: doFormatting ? formatNumberForDimensions(thickness as number) : thickness,
    });

    if (thicknessType) {
        return `${thicknessWithDimension} ${t(`domainModel:material.thicknessType.value.${thicknessType}`)}`;
    }

    return thicknessWithDimension;
};
